module.exports = __webpack_public_path__ + "img/driver-license.6d2f0755.png";